import type { DatabricksAiIntegration } from "@p0security/integrations-databricks-ai-shared/types";
import type { FrontendInstallContext } from "@p0security/integrations-installer";
import { installedIds } from "@p0security/shared/install/installed";

type InstallContext = FrontendInstallContext<DatabricksAiIntegration>;

// copy of installedKeys in packages/integrations/databricks/frontend/src/options.ts
/** The keys of the installed `component` items. */
export const listInstalledKeys = (
  context: InstallContext,
  component: keyof DatabricksAiIntegration
) =>
  // The integration's config is loaded live, so it may not be here yet.
  new Set(context.config ? installedIds(component, context.config) : []);
